import {List} from 'immutable';
import CanvasTypes from '~/constants/types/CanvasTypes';
import IconTypes from '~/constants/types/IconTypes';
import UploadTypes from '~/constants/types/UploadTypes';
import Color from '~/data/records/Color';
import SpotColor from '~/data/records/SpotColor';
import {getIcons} from '~/selectors/IconSelectors';

export const storageKey = 'ndx-recent-uploads-tab-sync';

// See explanation on how tab syncing works through this article
// https://daverivera90.medium.com/sharing-state-between-browser-tabs-with-redux-68899eb88fb7
export default function recentUploadsTabSync() {
  return next => action => {
    if (typeof action !== 'object') {
      next(action);
      return;
    }

    if (
      !action.syncRecentUploads &&
      [
        UploadTypes.UPLOAD_COMPLETE,
        CanvasTypes.REMOVE_RECENT_UPLOAD,
        IconTypes.ORDER_RECENT_UPLOADS
      ].includes(action.type)
    ) {
      const wrappedAction = Object.assign({syncRecentUploads: true}, action);
      localStorage.setItem(storageKey, JSON.stringify(wrappedAction));
    }

    next(action);
  };
}

export function recentUploadsTabSyncListener(store) {
  return () => {
    const storageValue = localStorage.getItem(storageKey);
    if (storageValue === null) return;

    const wrappedAction = JSON.parse(storageValue);

    if (typeof wrappedAction !== 'object') return;

    delete wrappedAction.syncRecentUploads;
    if (wrappedAction.type === UploadTypes.UPLOAD_COMPLETE) {
      wrappedAction.type = UploadTypes.ADD_RECENT_UPLOAD;

      // We shouldn't be able to upload an icon that already exists
      // This happens in the rare case that the recent uploads tab sync ends up sending an
      // action to its own tab
      if (getIcons(store.getState()).get(wrappedAction?.payload?.iconId)) {
        localStorage.removeItem(storageKey);
        return;
      }

      if (!wrappedAction?.payload?.productColor) {
        localStorage.removeItem(storageKey);
        return;
      }
      wrappedAction.payload.productColor = new Color(
        wrappedAction.payload.productColor
      );

      if (!wrappedAction?.payload?.icon?.spotColors) {
        localStorage.removeItem(storageKey);
        return;
      }
      wrappedAction.payload.icon.spotColors = List(
        wrappedAction.payload.icon.spotColors.map(c => new SpotColor(c))
      );
    }

    store.dispatch(wrappedAction);
    localStorage.removeItem(storageKey);
  };
}
